import React from 'react';
import { motion } from 'framer-motion';
import { ControllerIcon } from './ControllerIcon';
const problems = [{
  title: 'Invisible Rankings',
  desc: 'Great reviews buried on page 3 of search results. No structured data, no schema markup, no visibility.',
  icon: 'dpad' as const
}, {
  title: 'Leaking Revenue',
  desc: "Affiliate links that don't convert. Ad placements that annoy instead of earn. Monetization as an afterthought.",
  icon: 'buttons' as const
}, {
  title: 'Content Drift',
  desc: 'Hundreds of reviews with no architecture. No topical authority. No internal linking strategy.',
  icon: 'joystick' as const
}, {
  title: 'Stale Comparisons',
  desc: "Comparison tables that search engines can't parse and users don't trust.",
  icon: 'triggers' as const
}];
export function Problems() {
  return <section id="problems" className="py-32 bg-gameu-card relative border-y border-gameu-elevated" data-id="element-107">
      <div className="max-w-7xl mx-auto px-6" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-109">
          <h2 className="font-serif text-5xl md:text-6xl text-gameu-text mb-6" data-id="element-110">
            The Broken Loop
          </h2>
          <p className="text-gameu-muted text-lg max-w-2xl" data-id="element-111">
            Most gaming review sites are sitting on a goldmine of editorial
            content, but fail to capture the value due to structural flaws.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-112">
          {problems.map((problem, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-gameu-base p-8 border border-gameu-elevated hover:border-gameu-muted/30 transition-colors group" data-id="element-113">
              <div className="w-12 h-12 rounded-full bg-gameu-elevated flex items-center justify-center mb-6 text-gameu-muted group-hover:text-gameu-accent transition-colors" data-id="element-114">
                <ControllerIcon variant={problem.icon} className="w-6 h-6" data-id="element-115" />
              </div>
              <h3 className="text-2xl font-serif text-gameu-text mb-4" data-id="element-116">
                {problem.title}
              </h3>
              <p className="text-gameu-muted leading-relaxed" data-id="element-117">{problem.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}